
import React, { useEffect, useState } from 'react';
import Header from '../Components/Header';
import { useCategoryStore } from '../store/useCategoryStore';
import AttributeForm, { IOSSwitch } from './AttributeForm';
import { useProductStore } from '../store/useProductStore';
import { useLocation, useNavigate } from 'react-router-dom';
import Loader from '../Components/loader/Loader';
import Sidebar from '../Components/Sidebar';
import { FormControlLabel } from '@mui/material';
import { useVendorStore } from '../store/useVendorStore';

export default function ProductAdd() {

  const { getCategory, category } = useCategoryStore()
  const [isMultipleSizes, setIsMultipleSizes] = useState(true);
  const { addProduct, getProductById, loading } = useProductStore()
  const [items, setItem] = useState('')
  const location = useLocation();
  const navigate = useNavigate()
  const { nonPaginatedVendor, getVendor } = useVendorStore()

  const [inputList, setInputList] = useState([{
    unit: "",
    basePrice: "",
    retailPrice: "",
    stockQuantity: "",
    weight: "",
    dimensions: "",
    discount: "",
  }]);
  const [sizeList, setSizeList] = useState([{ size: "" }]);
  const [highlights, setHiglights] = useState('');
  const [ingredients, setIngredients] = useState('');
  const [specification, setSpecification] = useState('');

  const [formData, setFormData] = useState({
    brand: '',
    name: '',
    category: '',
    manufacturer: '',
    distributor: '',
    sku_id: '',
    highlights: [],
    ingredients: [],
    specification: [],
    warranty: '',
    customWarranty: '',
    sterility: '',
    disposable: '',
    usage: '',
    material: '',
    prescriptionRequired: '',
    replacement: '',
    description: '',
    is_featured: true,
    isPriceDisplay: '',
    fda: '',
    notes: '',
    displayNotes: '',
    attributes: [
      {
        size: '',
        size_attribute: [
          {
            basePrice: null,
            color: [],
            retailPrice: null,
            stock_quantity: null,
            weight: [],
            dimensions: '',
            is_default: false,
            discount: null
          }
        ]
      }
    ],
    images: []
  });
  const [errors, setErrors] = useState({});

  const handleChangeList = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList];
    list[index][name] = value;
    setInputList(list);
  };
  // more size 
  const handleChangeSizeList = (e, index) => {
    const { name, value } = e.target;
    const sList = [...sizeList];
    sList[index][name] = value;
    setSizeList(sList);
    console.log(sizeList);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  }
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [pictureUrl, setPictureUrl] = useState([])


  const handleFileChange = (e) => {
    const files = Array.from(e.target?.files || []);
    if (!files.length) return;

    const newImageUrls = files.map(file => URL.createObjectURL(file));
    const updatedPictureUrls = [...pictureUrl, ...newImageUrls];
    const updatedImages = [...formData.images, ...files];

    setPictureUrl(updatedPictureUrls);
    setFormData(prev => ({
      ...prev,
      images: updatedImages,
    }));
  };


  const handleDeleteImage = (index) => {
    const updated = [...pictureUrl];
    const updateFormDataImages = [...formData.images]
    updated.splice(index, 1);
    updateFormDataImages.splice(index, 1);
    setPictureUrl(updated);
    setFormData({
      ...formData,
      images: updateFormDataImages
    })
  };


  const validate = () => {
    let tempErrors = {};
    if (!formData.name) {
      tempErrors.name = 'Name is required.';
    }
    if (!formData.brand) {
      tempErrors.brand = 'Brand Name is required.';
    }
    if (!formData.category) {
      tempErrors.category = 'Category field is required.';
    }
    if (!formData.files) {
      tempErrors.files = 'Image field is required.';
    }
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    const formDataImage = new FormData();
    formDataImage.append(
      "myFile",
      selectedFiles.name
    );
    if (validate()) {
      alert('Form submitted successfully!');
    }

    try {
      const data = await addProduct(formData, items)
      if (data) {
        navigate(-1)
      }
    } catch (error) {
      console.log(error)
    }
    // console.log(formData)

  };


  // handle click event of the Remove button
  const handleRemoveClick = (index) => {
    const list = [...inputList];
    const remove = list.filter((_, indexFilter) => !(indexFilter === index));
    // list.splice(index, 1);
    setInputList(remove);
  };

  // handle click event of the Add button
  const handleAddClick = () => {
    setInputList([...inputList, { unit: "", basePrice: "" }]);
  };

  // handle click event of the Remove More Size button
  const handleRemoveSizeClick = (index) => {
    const sList = [...sizeList];
    const remove = sList.filter((_, indexFilter) => !(indexFilter === index));
    // list.splice(index, 1);
    setSizeList(remove);
  };

  // handle click event of the Add More Size button
  const handleAddSizeClick = () => {
    setSizeList([...sizeList, { size: "" }]);
  };


  const getDetailFunction = async (id) => {
    const product = await getProductById(id)

    const predefinedWarranty = ["1 year", "2 year", "3 year", "4 year", "5 year", "No Warranty"];
    const isCustomWarranty = product?.warranty && !predefinedWarranty.includes(product.warranty);
    setFormData({
      brand: product?.brand || '',
      name: product?.name || '',
      category: product?.category || '',
      material: product?.material || '',
      manufacturer: product?.manufacturer || '',
      distributor: product?.distributor || '',
      sku_id: product?.sku_id || '',
      highlights: product?.highlights || [],
      ingredients: product?.ingredients || [],
      specification: product?.specification || [],
      warranty: isCustomWarranty ? "custom" : product?.warranty || '',
      customWarranty: isCustomWarranty ? product?.warranty : "",
      sterility: product?.sterility || '',
      disposable: product?.disposable || '',
      usage: product?.usage || '',
      prescriptionRequired: product?.prescriptionRequired || '',
      replacement: product?.replacement || '',
      description: product?.description || '',
      is_featured: product?.is_featured || false,
      isPriceDisplay: product?.isPriceDisplay,
      fda: product?.fda,
      notes: product?.notes,
      displayNotes: product?.displayNotes,
      attributes: product?.attributes || [
        {
          size: '',
          size_attribute: [
            {
              color: [],
              basePrice: null,
              retailPrice: null,
              stock_quantity: null,
              weight: [],
              dimensions: '',
              is_default: false,
              discount: null
            }
          ]
        }
      ],
      images: product?.images || []
    });

    setPictureUrl(product?.images)
  }

  const handleDelete = (index) => {
    const data = formData.specification || [];

    const filterData = data.filter((ele, i) => i !== index);

    setFormData((prev) => ({
      ...prev,
      specification: filterData,
    }));
  };

  const handleSaveSpecification = () => {
    if (specification.trim() !== "") {
      setFormData((prev) => ({
        ...prev,
        specification: [...(prev.specification || []), specification.trim()]
      }));
      setSpecification("");
    }
  };

  const handleSavehighlights = () => {
    if (highlights.trim() !== "") {
      setFormData((prev) => ({
        ...prev,
        highlights: [...(prev.highlights || []), highlights.trim()]
      }));
      setHiglights("");
    }
  };

  const handleChangePriceDisplay = (e) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: checked
    }));
  };

  const getAllVendorFunctioncaller = async () => {
    const data = await getVendor()
  }

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const id = params.get("id");
    if (id) {
      setItem(id)
      getDetailFunction(id)
    }

    const getFeaturedCategory = async () => {
      await getCategory()
    }
    getFeaturedCategory()
    getAllVendorFunctioncaller()
  }, [location.search])


  return (
    <div id="dashboard-root"
      className="flex min-h-[1000px] w-full">
      {/* <!-- Sidebar --> */}
      <Sidebar />
      {/* <!-- Main Content --> */}
      <main id="main-content" className="flex-1 px-10 py-8">
        {/* <!-- Header --> */}
        <Header title="Add New Product" />
        {/* product table  */}

        <Loader loading={loading} />
        {/* <div class="relative overflow-x-auto shadow-md sm:rounded-lg mb-6">
        <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
          <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" class="px-6 py-3">
                Product name
              </th>
              <th scope="col" class="px-6 py-3">
                Brand Name
              </th>
              <th scope="col" class="px-6 py-3">
                Category
              </th>
              <th scope="col" class="px-6 py-3">
                Size
              </th>
            </tr>
          </thead>
          <tbody>
  
            <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 border-gray-200">
              <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                {formData.name}
              </th>
              <td class="px-6 py-4">
                {formData.brand}
              </td>
              <td class="px-6 py-4">
                {formData.category}
              </td>
              <td class="px-6 py-4">
                {sizeList[0].size}
              </td>
            </tr>
           
          </tbody>
        </table>
      </div> */}

        {/* product table End  */}
        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6 p-8 bg-white">
            <div>
              <label
                htmlFor="brand"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Brand Name
              </label>
              <input
                type="text"
                id="brand"
                name="brand"
                value={formData.brand}
                onChange={(e) => handleChange(e)}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500"
              />
              {errors.brand && <p style={{ color: "red" }}>{errors.brand}</p>}
            </div>

            <div>
              <label
                htmlFor="name"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Product Name
                <span className="text-red-500 ml-1">*</span>
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500"
              />
              {errors.name && <p style={{ color: "red" }}>{errors.name}</p>}
            </div>

            <div>
              <label
                htmlFor="category"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Category
                <span className="text-red-500 ml-1">*</span>
              </label>
              <select
                id="category"
                name="category"
                value={formData.category}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500"
              >
                <option value="">Select Category</option>
                {
                  (category || []).map((ele, i) => (
                    <option value={ele?._id} key={i}>{ele?.name}</option>
                  ))
                }
              </select>
              {errors.category && <p style={{ color: "red" }}>{errors.category}</p>}
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                SKU Id
                <span className="text-red-500 ml-1">*</span>
              </label>
              <input
                type="text"
                name="sku_id"
                value={formData.sku_id}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500"
              />
            </div>
            <div>
              <label
                htmlFor="manufacturer"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Manufacturer
              </label>
              <input
                type="text"
                id="manufacturer"
                name="manufacturer"
                value={formData.manufacturer}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500"
              />
              {errors.manufacturer && (
                <p style={{ color: "red" }}>{errors.manufacturer}</p>
              )}
            </div>
            <div>
              <label
                htmlFor="distributor"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Vendor
              </label>
              <select
                id="distributor"
                name="distributor"
                value={formData.distributor}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500"
              >
                <option value="">Select distributor</option>
                {
                  (nonPaginatedVendor || []).map((ele, i) => (
                    <option value={ele?._id} key={i}>{ele?.vendorName}</option>
                  ))
                }
              </select>
              {errors.category && <p style={{ color: "red" }}>{errors.category}</p>}
            </div>
            {/* <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">
              Highlights
            </label>
            <select id="highlights"
              name="highlights"
              value={formData.highlights}
              onChange={handleChange}
              class="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500">
              <option value="">Select Highlights</option>
              <option value="10 sec">10-second</option>
              <option value="20 sec">20-second</option>
              <option value="30 sec">30-second</option>
            </select>
          </div> */}
            {/* <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">
              Ingredients
            </label>
            <select id="ingredients"
              name="ingredients"
              value={formData.ingredients}
              onChange={handleChange}
              class="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500">
              <option value="">Select</option>
              <option value="false">Not Applicable</option>
              <option value="true">Applicable</option>
            </select>
          </div> */}
            {/* <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">
              Do You Want To show the Price
            </label>
            <select id="isPriceDisplay"
              name="isPriceDisplay"
              value={formData.isPriceDisplay}
              onChange={handleChange}
              class="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500">
              <option value=''>Select</option>
              <option value={true}>Yes</option>
              <option value={false}>No</option>
            </select>
          </div> */}

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Status
                <span className="text-red-500 ml-1">*</span>
              </label>
              <select id="is_featured"
                name="is_featured"
                value={formData.is_featured}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500">
                <option value="">Select Status</option>
                <option value={true}>Active</option>
                <option value={false}>InActive</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                FDA
              </label>
              <select id="fda"
                name="fda"
                value={formData.fda}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500">
                <option value="">Select FDA</option>
                <option value='Class I'>Class I</option>
                <option value='Class II'>Class II</option>
                <option value='Class III'>Class III</option>
                <option value='N/A'>N/A</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Warranty
              </label>
              <select
                id="warranty"
                name="warranty"
                value={formData.warranty}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500"
              >
                <option value="1 yr">1 Year</option>
                <option value="2 yr">2 Year</option>
                <option value="3 yr">3 Year</option>
                <option value="4 yr">4 Year</option>
                <option value="5 yr">5 Year</option>
                <option value="No Warranty">No Warranty</option>
                <option value="custom">Custom</option>
              </select>

              {/* Show input box only if custom is selected */}
              {formData.warranty === "custom" && (
                <input
                  type="text"
                  name="customWarranty"
                  placeholder="Enter warranty (e.g. 3 Years)"
                  value={formData.customWarranty || ""}
                  onChange={handleChange}
                  className="w-full mt-2 border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500"
                />
              )}
            </div>


            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Sterile
              </label>
              <select id="sterility"
                name="sterility"
                value={formData.sterility}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500">
                <option value="true">Sterile</option>
                <option value="false">Not Sterile</option>
                <option value="not applicable">Not Applicaple</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Disposable
              </label>
              <select
                id="disposable"
                name="disposable"
                value={formData.disposable}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500">
                <option value="">Select the product is disposable</option>
                <option value={true}>Yes</option>
                <option value={false}>No</option>
                <option value="not applicable">Not Applicaple</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Usage
              </label>
              <select
                id="usage"
                name="usage"
                value={formData.usage}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500">
                <option value="">Select Usage</option>
                <option value="personal use">Personal Use</option>
                <option value="clinic use">Clinic Use</option>
                <option value="other">Other</option>
                <option value="not applicable">Not Applicaple</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Prescription Required
              </label>
              <select
                id="prescriptionRequired"
                name="prescriptionRequired"
                value={formData.prescriptionRequired}
                onChange={handleChange} className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500">
                <option value="true">Yes</option>
                <option value="false">No</option>
                <option value="not applicable">Not Applicaple</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Replacement Policy
              </label>
              <select
                id="replacement"
                name="replacement"
                value={formData.replacement}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500">
                <option value="7 days">7-day</option>
                <option value="14 days">14-day</option>
                <option value="not applicable">Not Applicaple</option>
              </select>
            </div>
            <div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Product Images
                </label>

                <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center cursor-pointer relative">
                  <i className="fa-solid fa-cloud-arrow-up text-gray-400 text-3xl mb-2"></i>
                  <p className="text-sm text-gray-500">Click or drag files to upload</p>

                  {/* <input
                  onChange={handleFileChange} type="file" name="files" multiple /> */}
                  <input
                    type="file"
                    name="files"
                    multiple
                    onChange={handleFileChange}
                    className="absolute inset-0 opacity-0 cursor-pointer"
                  />
                </div>
              </div>

              <div className='flex gap-2 flex-wrap'>
                {pictureUrl.length >= 1 &&
                  pictureUrl.map((ele, i) => (
                    <div key={i} className='relative w-24 h-24 mt-2'>
                      <img src={ele} className='w-full h-full object-cover rounded' />

                      <button
                        type='button'
                        onClick={() => handleDeleteImage(i)}
                        className='absolute top-[-6px] right-[-6px] bg-red-500 text-white rounded-full w-5 h-5 text-xs flex items-center justify-center hover:bg-red-600'
                        title='Delete Image'
                      >
                        ❌
                      </button>
                    </div>
                  ))}
              </div>
            </div>
            <div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Product Note
                </label>
                <textarea
                  name="notes"
                  value={formData.notes}
                  onChange={handleChange}
                  rows="4"
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500"
                ></textarea>
              </div>
              <div className='flex justify-right items-center gap-4 mt-4'>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Show this to the user?
                </label>
                <FormControlLabel
                  control={
                    <IOSSwitch
                      sx={{ m: 1 }}
                      id="displayNotes"
                      name="displayNotes"
                      value={formData?.displayNotes}
                      onChange={(e) => handleChangePriceDisplay(e)}
                      checked={formData?.displayNotes}
                    />
                  }
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Material
              </label>
              <select id="is_featured"
                name="material"
                value={formData.material}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500">
                <option value="">Select Status</option>
                <option value='latex'>Latex</option>
                <option value='latexFree'>Latex Free</option>
              </select>
            </div>

          </div>
          <div className='flex gap-6'>
            <label className="block text-sm font-medium text-gray-700 mt-3">
              Do You Want To Show the Price
            </label>
            <FormControlLabel
              control={
                <IOSSwitch
                  sx={{ m: 1 }}
                  id="isPriceDisplay"
                  name="isPriceDisplay"
                  value={formData?.isPriceDisplay}
                  onChange={(e) => handleChangePriceDisplay(e)}
                  checked={formData?.isPriceDisplay}
                />
              }
            />
          </div>
          <AttributeForm
            isPriceDisplay={formData?.isPriceDisplay}
            formState={formData.attributes}
            setFormState={(updatedAttributes) =>
              setFormData(prev => ({ ...prev, attributes: updatedAttributes }))
            }
            isMultipleSizes={isMultipleSizes}
          />
          <div className='bg-white p-4'>
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Description
              </label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleChange}
                rows="4"
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500"
              ></textarea>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Product Specification
              </label>
              {formData?.specification?.length > 0 && (
                <div className="border border-dotted border-gray-400 p-4 rounded-md mb-4">
                  <h3 className="font-semibold mb-2">Registered Specifications:</h3>
                  <ul className="list-disc pl-5 space-y-2">
                    {formData.specification.map((ele, index) => (
                      <li key={index} className="flex items-center justify-between">
                        <span>{ele}</span>
                        <button
                          onClick={() => handleDelete(index)}
                          className="text-red-500 hover:underline ml-4 text-sm"
                        >
                          Delete
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              )}


              <input
                name="specification"
                value={specification}
                onChange={(e) => setSpecification(e.target.value)}
                rows="4"
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500 mb-4"
              />

              <div
                onClick={handleSaveSpecification}
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 w-[200px]"
              >
                Add Specification
              </div>
            </div>
          </div>
          {/* <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">
              Product Highlights
            </label>
            {(formData?.highlights?.length > 0) && (
              <div className="border border-dotted border-gray-400 p-4 rounded-md mb-4">
                <h3 className="font-semibold mb-2">Registered highlights:</h3>
                <ul className="list-disc pl-5">
                  {formData.highlights.map((ele, index) => (
                    <li key={index}>{ele}</li>
                  ))}
                </ul>
              </div>
            )}

            <input
              name="highlights"
              value={highlights}
              onChange={(e) => setHiglights(e.target.value)}
              rows="4"
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500 mb-4"
            />

            <div
              onClick={handleSavehighlights}
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 w-[200px]"
            >
              Save the highlights
            </div>
          </div> */}

          <div className="border-t pt-6 flex justify-end space-x-3">
            <button
              type="button"
              className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700"
              id="cancel-product"
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-primary-600 text-white rounded-lg"
            >
              Submit
            </button>
          </div>
        </form>
      </main>
    </div>
  );
}
